import React, {useState} from 'react';
import {useLoading} from "../../../components/context/LoadingContext";
import {collection, doc, getDocs, query, setDoc, where} from "firebase/firestore";
import {auth, db} from "../../../components/Firebase/Firebase";
import {createUserWithEmailAndPassword} from "firebase/auth";
import {Button, IconButton, InputAdornment} from "@mui/material";
import TextField from "@mui/material/TextField";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import logo from '../../../assets/images/logo.svg'
import {useNavigate} from "react-router-dom";

const SignUpPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [birthday, setBirthday] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [completeMessage, setCompleteMessage] = useState(null);
    const [isLoading, setIsLoading] = useLoading();
    const navigate = useNavigate();

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const usersQuery = query(collection(db, "user"), where("email", "==", email));
            const usersSnapshot = await getDocs(usersQuery);

            if (!usersSnapshot.empty) {
                const userData = usersSnapshot.docs[0].data();
                await setDoc(doc(db, 'admin', usersSnapshot.docs[0].id), userData);
                setCompleteMessage("Администратор добавлен");
            } else {
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;
                const userInfo = {
                    birthday,
                    email,
                    name,
                    phone,
                    uid: user.uid,
                };

                await setDoc(doc(db, 'user', user.uid), userInfo);
                await setDoc(doc(db, 'admin', user.uid), userInfo);
                setCompleteMessage("Администратор добавлен");
                navigate('/')
            }
        } catch (error) {
            console.error('Error:', error);
            setError(error.message);
        }
        setIsLoading(false);
    };

    return (
        <section className="loginSection">
            <div className="loginBox">
                <div className="loginLogo text-center">
                    <img src={logo} alt="logo"/>
                    <span className="ml-2">Admin</span>
                </div>
                <form onSubmit={handleSubmit} className="loginForm">
                    <TextField
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        label="Email"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#fff',
                                },
                            },
                        }}
                    />
                    <TextField
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        type={showPassword ? 'text' : 'password'}
                        label="Пароль"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#fff',
                                },
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff className='eyeIcon'/> : <Visibility className='eyeIcon'/>}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        label="Имя"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#fff',
                                },
                            },
                        }}
                    />
                    <TextField
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        type="text"
                        label="Телефон"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#fff',
                                },
                            },
                        }}
                    />
                    <TextField
                        value={birthday}
                        onChange={(e) => setBirthday(e.target.value)}
                        type="date"
                        label="Дата рождения"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                    '&::-webkit-calendar-picker-indicator': {
                                        filter: 'invert(1)',
                                        width: '24px',
                                        height: '24px',
                                    },
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#CEFC4C',
                                },
                            },
                        }}
                    />
                    {error && <div className="error">{error}</div>}
                    {completeMessage && <div className="completeMessage">{completeMessage}</div>}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        className="logInButton"
                    >
                        Добавить администратора
                    </Button>
                </form>
            </div>
        </section>
    );
};

export default SignUpPage;